import { render, staticRenderFns } from "./eventAsk.vue?vue&type=template&id=4b11313a"
import script from "./eventAsk.vue?vue&type=script&lang=js"
export * from "./eventAsk.vue?vue&type=script&lang=js"
import style0 from "./eventAsk.vue?vue&type=style&index=0&id=4b11313a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports